import React, { useEffect, useState } from "react";
import laptop from "../../../assets/laptop.png"; // Replace with your image path

const statsData = [
  { label: "Influencers Database", value: 2000 },
  { label: "Ready to work on ACPV", value: 500 },
  { label: "Brands Engaged", value: 25 },
  { label: "In Discussion", value: 11 }, // Duplicate from image
];

const AnimatedCounter = ({ target }) => {
  const [count, setCount] = useState(0);

  useEffect(() => {
    let start = 0;
    const duration = 1000; // 1 second
    const stepTime = duration / target;
    const timer = setInterval(() => {
      start += 5;
      setCount(start);
      if (start >= target) clearInterval(timer);
    }, stepTime);
    return () => clearInterval(timer);
  }, [target]);

  return <span className="text-3xl font-bold">{count}+</span>;
};

const Reporting = () => {
  return (
    <div className="flex md:flex-row xs:flex-col items-center justify-center md:py-6 md:px-20 xs:px-4 bg-white" style={{ fontFamily: "Gilroy-Medium" }}>
      {/* Left: Stats */}
      <div className="grid grid-cols-2 gap-6 md:w-1/2 ">
        {statsData.map((item, idx) => (
          <div
            key={idx}
            className="bg-white rounded-lg shadow-md p-6 text-center border-2 border-gray-300 hover:shadow-lg transition-shadow duration-300 hover:-translate-y-2 transition-transform"
          >
            <AnimatedCounter target={item.value} />
            <p className="mt-2 text-gray-600">{item.label}</p>
          </div>
        ))}
      </div>

      {/* Right: Rotated Laptop Image - 30% out of the frame */}
      <div className="md:w-1/2 ml-5 xs:w-full flex justify-center  overflow-visible lg:block">
      <div className="relative flex items-center justify-center">
        <img
          src={laptop} // your uploaded image
          alt="Laptop Reporting"
          className="w-[300px] lg:w-[450px] translate-x-[30%] xs:w-[400px] xs:translate-x-[0%] xs:mt-3 transition-transform duration-500 duration-300 hover:-translate-y-2 transition-transform"
        />
        </div>
      </div>
    </div>
  );
};

export default Reporting;
